import { CompetitionTeam } from './competition-team'
import { Injectable } from '@angular/core'

@Injectable()
export class CompetitionTeamSerializer {
  fromJson(json: any): CompetitionTeam {
    const competitionTeam = {
      ...json
    }

    return competitionTeam
  }

  toJson(competitionTeam: CompetitionTeam): any {
    return {
      ...competitionTeam,
      teamRegistrationDate: competitionTeam.teamRegistrationDate.toISOString()
    }
  }
}
